export class BlogsAxios {
  static async getBlogs() {
    return fetch('https://atiragrup.com/wp-json/wp/v2/posts?categories=90')
      .then((response) => response.json())
      .then((data) => data)
      .catch((e) => {
        console.log('Error fetching blogs:', e);
        return [];
      });
  }
}
